import { useEffect, useState } from "react";
import { AiFillBackward } from "react-icons/ai";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useEditUserMutation } from "../../features/api/userApi";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../components/baseUrl";
const UpdateUser = () => {
  const location = useLocation();
  const stateUser = location?.state;
  const id = stateUser?.id;
  const [role, setUserType] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(
    stateUser?.signature
      ? `${API_BASE_URL}/uploads/${stateUser?.signature}`
      : null
  );

  const [pass, setPass] = useState("");
  const [conPass, setConPass] = useState("");
  const userType = ["sadmin", "admin", "user"];
  const [error, setError] = useState(null);

  useEffect(() => {
    if (stateUser) {
      setUserType(stateUser?.role);
      setName(stateUser?.name);
      setEmail(stateUser?.email);
      setPass(stateUser?.pass);
    }
  }, [stateUser]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  const navigate = useNavigate();
  const [editUser] = useEditUserMutation();
  const handleUpdate = async () => {
    try {
      if (conPass === "") {
        toast.error("Please enter confirm password");
      } else {
        const formData = new FormData();
        formData.append("role", role);
        formData.append("name", name);
        formData.append("email", email);
        if (image) formData.append("signature", image);
        formData.append("pass", pass);

        const response = await axios.patch(
          `${API_BASE_URL}/api/users/${id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response?.error) {
          toast.error(response?.error?.data?.error);
        } else {
          navigate("/dashboard/user");
        }
      }
    } catch (error) {
      setError(error?.response?.data?.error);
    }
  };
  return (
    <div className=" overflow-auto">
      <div className="flex justify-between items-center p-4">
        <h1 className="text-xl font-bold">Update User </h1>
        <Link
          to="/dashboard/user"
          className="bg-blue-500 px-2 py-1 rounded font-bold text-white flex items-center gap-x-1"
        >
          <AiFillBackward /> User List{" "}
        </Link>
      </div>
      <div>
        <div className="p-4 m-4 border">
          <form className=" grid grid-cols-2 lg:grid-cols-3  gap-6">
            <div className="flex flex-col gap-1">
              <label>User Type</label>
              <select
                onChange={(e) => setUserType(e.target.value)}
                className="border h-8 pl-1"
              >
                <option>{stateUser?.role}</option>
                {userType?.map((type, i) => (
                  <option key={i}>{type}</option>
                ))}
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label>Name</label>
              <input
                type="text"
                onChange={(e) => setName(e.target.value)}
                defaultValue={stateUser?.name}
                className="border h-8 pl-1"
                required
              />
            </div>
            <div className="flex flex-col gap-1">
              <label>Email</label>
              <input
                type="email"
                onChange={(e) => setEmail(e.target.value)}
                defaultValue={stateUser?.email}
                className="border h-8 pl-1"
                required
              />
            </div>

            <div className="flex flex-col gap-1">
              <label>Image</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="border h-8 pl-1"
              />
              {preview && (
                <img
                  src={preview}
                  alt="Preview"
                  style={{ maxWidth: "100%", maxHeight: "200px" }}
                />
              )}
            </div>
            <div className="flex flex-col gap-1">
              <label>Password</label>
              <input
                type="password"
                onChange={(e) => setPass(e.target.value)}
                className="border h-8 pl-1"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label>Confirm Password</label>
              <input
                type="password"
                onChange={(e) => setConPass(e.target.value)}
                className="border h-8 pl-1"
              />
            </div>
          </form>
          {conPass && pass !== conPass && (
            <p className="text-red-500 mt-2 font-bold">
              Password did not matched
            </p>
          )}
          {error && (
            <p className="text-center text-red-500 font-bold mt-6">{error}</p>
          )}
          <button
            onClick={handleUpdate}
            className="bg-blue-500 px-4 py-1 text-white font-bold block mx-auto mt-4"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateUser;
